<template>
  <div>
    <el-dialog title="Update Refund Info" :close-on-click-modal="false" :visible.sync="visible" width="1200px" top="3vh">
      <div class="pb20 tableWrap">
        <el-table border :data="detail.orderRefundList || []">
          <el-table-column label="Apply Time" prop="applyTime" align="center" width="110px" />
          <el-table-column label="Apply Reason" prop="applyReason" align="center" />
          <el-table-column label="Fail Reason" prop="failReason" align="center" />
          <el-table-column label="Refund Status" align="center" width="150px">
            <template slot-scope="scope">
              <p>{{ refundStatusFormat(scope.row.status) }}</p>
            </template>
          </el-table-column>
          <el-table-column label="Action" align="center" width="80px">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="minWd0"
                @click="updateHandle(scope.row)"
                v-if="['REFUND_INFO_NOT_ENOUGH', 'REFUND_INFO_UPDATED'].includes(scope.row.status)"
              >
                Edit
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 更新退款信息 - 弹窗 -->
    <Update ref="updateRef" :detail="detail" />
  </div>
</template>

<script>
import Update from "./Update";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Update,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    // 初始化
    async init() {
      this.visible = true;
    },
    // 编辑
    updateHandle(data) {
      this.$refs.updateRef.init(data);
    },
  },
};
</script>
